//忠诚度管理-奖品中心
import { get, post, postJson, put, putUrl, postJsonBlob } from "../axios2";

const RESOURCE_BASE_PATH = "/sellerCouponWrite";

const RESOURCE_BASE_PATH1 = "/beansPlan";

const RESOURCE_BASE_PATH2 = "/assetsPlan";

const RESOURCE_BASE_PATH3 = "/redPacketPlan";

const RESOURCE_BASE_PATH4 = "/public";

//获取当前登陆用户菜单列表
export const getMenuList = (p) => get(`/menus`, p);

//查询优惠券列表
export const couponList = (p) => postJson(`${RESOURCE_BASE_PATH}/list`, p);

//查询京豆
export const jingdouList = (p) => postJson(`${RESOURCE_BASE_PATH1}/list`, p);

//查询京豆发放明细
export const jingdouRecordList = (p) =>
  postJson(`${RESOURCE_BASE_PATH1}/record/list`, p);

//查询京豆账户余额
export const jingdouAccount = (p) =>
  get(`${RESOURCE_BASE_PATH1}/accountBalance`, p);

//创建京豆
export const jingdouSet = (p) => postJson(`${RESOURCE_BASE_PATH1}`, p);

//京豆详情回显
export const jignduoEcho = (id) => get(`${RESOURCE_BASE_PATH1}/detail/${id}`);

//查询账户余额
export const allAccount = (p) =>
  get(`${RESOURCE_BASE_PATH2}/accountBalance/list`, p);

//查询京东E卡,爱奇艺会员,京豆PLUS会员
export const allAccountList = (p) => postJson(`${RESOURCE_BASE_PATH2}/list`, p);

//创建京东E卡,爱奇艺会员,京豆PLUS会员
export const setAccountList = (p) => postJson(`${RESOURCE_BASE_PATH2}`, p);

//修改资产
export const modifyAssets = (p) => put(`${RESOURCE_BASE_PATH2}`, p);

//获取资产发放明细
export const getAccountList = (p) =>
  postJson(`${RESOURCE_BASE_PATH2}/record/list`, p);

//查询红包
export const redPacketList = (p) => postJson(`${RESOURCE_BASE_PATH3}/list`, p);

//创建红包
export const setRedPacket = (p) => postJson(`${RESOURCE_BASE_PATH3}`, p);

//红包发放明细
export const dispenseRedPacket = (p) =>
  postJson(`${RESOURCE_BASE_PATH3}/record/list`, p);

//停止红包
export const stopRedPacket = (id) =>
  putUrl(`${RESOURCE_BASE_PATH3}/stop/${id}`);

//停止京豆计划
export const stopActivity = (id) => putUrl(`${RESOURCE_BASE_PATH1}/stop/${id}`);
//停止资产
export const stopAssets = (id) => putUrl(`${RESOURCE_BASE_PATH2}/stop/${id}`);

//判断是否开通积分
export const judgingActivation = (p) =>
  get(`${RESOURCE_BASE_PATH4}/isPointsEnabled`, p);

//获取京豆供应商简码列表
export const getSupplierAccountList = (p) =>
  get(`${RESOURCE_BASE_PATH1}/account/list`, p);

//添加供应商简码
export const addBeansCode = (p) =>
  get(`${RESOURCE_BASE_PATH1}/addBeansCode`, p);

//判断京豆是否授权
export const isauth = (p) => get(`${RESOURCE_BASE_PATH1}/isauth`, p);

//礼品卡汇总数量查询接口
export const getGiftCardCount = (p) => get("/giftCardPlan/getGiftCardCount", p);

//礼品卡分页查询接口
export const getGiftCardPage = (p) => get("/giftCardPlan/getGiftCardPage", p);

// 创建礼品卡计划接口
export const addGiftCard = (p) => postJson("/giftCardPlan/addGiftCard", p);

// 导入卡号/卡密接口
export const importCardKey = (p) => postJson("/giftCardPlan/importCardKey", p);

// 修改礼品卡
export const updateGiftCard = (p) => put("/giftCardPlan/updateGiftCard", p);

// 终止活动计划
export const stopGiftCard = (p) => put("/giftCardPlan/stopGiftCard", p);

// 发放明细分页接口
export const getGiftCardDetailPage = (p) =>
  get("/giftCardPlan/getGiftCardDetailPage", p);

// 关联活动列表接口
export const getRelActivity = (p) =>
  get(`/giftCardPlan/getRelActivity?planId=${p}`);

// 结束全部关联活动接口
export const closeRelActivity = (p) =>
  get(`/giftCardPlan/closeRelActivity?planId=${p}`);

// 未发放明细分页接口
export const getNotSendGiftCardDetailPage = (p) =>
  get(
    "/giftCardPlan/getNotSendGiftCardDetailPage?id=" +
      p.id +
      "&current=" +
      p.current +
      "&size=" +
      p.size
  );

//导出数据
export const exportNotSendDetail = (p) =>
  postJsonBlob(`/jd-hd-web/giftCardPlan/exportNotSendDetail/hd`, p);

/***
 * 检查商品是否有影分身或虚拟套装
 * @param p
 */
export const checkProduct = p => postJson(`/public/checkProduct`,p)

//红包详情回显
export const redEnvelopeDetail = (id) =>
  get(`${RESOURCE_BASE_PATH3}/detail/${id}`);

// 查询京豆计划绑定活动记录
export const getBindingRecord = (p) => get('/beansPlan/bindingRecord', p);

// 更新京豆计划是否释放库存状态
export const updateBindingStatus = (p) => postJson('/beansPlan/updateBindingStatus', p);